<template>
    <div class="project-detail-container">
        <ProjectInfo :dataInfo="dataInfo" />
    </div>
</template>
<script>
import * as api from '@/api/hr/assessMent'
import FrameWrapper from "@/components/frame/zsFrame"
import ProjectInfo from "./../../components/projectInfo.vue"
import moment from "moment"
export default {
    name: 'discussDecideDetail',
    components: {
        FrameWrapper,
        ProjectInfo
    },
    data() {
        return {
            tableData: [],
            id: -1,
            dataInfo: {

            }

        }
    },
    mounted() {
        this.id = this.$route.params.id;
        // this.queryDetail(this.id)
    },
    methods: {
        moment,
        async queryDetail(id) {
            let res = await api.getDetail({ id })
            if (res.data.code == 200) {
                this.formInfo = Object.assign({}, res.data.data)

            }

        },
    }
}
</script>

<style lang="scss" scoped>
.detail_wrapper {
    // padding: 20px !important;
    background-color: #fff;

    .header_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid rgb(233, 233, 233);

        .header_left {
            font-weight: 700;
            font-style: normal;
            font-size: 18px;
            color: #333
        }

        .header_right {}

    }

    .con_wrapper {
        .content_slot {
            padding: 20px 1rem;
        }
    }
}

:deep(.descriptions_label) {
    background-color: #ECF5FF !important;
}

/deep/.ant-descriptions-item .ant-descriptions-item-label {
    color: #999999;
    font-weight: 400;
    text-align: right;
}

/deep/.ant-descriptions-item .ant-descriptions-item-content {
    color: #333333;
    font-weight: 400;
}
</style>